import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import Video from './Video';

/**
 * @param {string} ext
 * @param {string} publicId
 * @param {string} resourceType
 * @param {string} type
 * @param {number} version
 * @param {number} width
 * @param {string} quality
 */
function buildUrl(ext, publicId, resourceType, type, version, width, quality) {
  return `https://res.cloudinary.com/fftech/${resourceType}/${type}/c_scale,w_${width},f_${ext},q_${quality}/v${version}/${publicId}.${ext}`;
}

/**
 * @param {string} publicId
 * @param {string} type
 * @param {number} version
 * @param {Array<number>=} breakpoints
 */
function buildVideoUrls(
  publicId,
  type,
  version,
  breakpoints = [1000],
  quality = 'auto',
) {
  return breakpoints.map(width => ({
    width,
    urls: [
      buildUrl('webm', publicId, 'video', type, version, width, quality),
      buildUrl('mp4', publicId, 'video', type, version, width, quality),
    ],
  }));
}

/**
 * @param {FF.CloudinaryMedia} props
 * */
export default function CloudinaryMedia({
  className = '',
  lazyload = true,
  autoPlay = !lazyload,
  public_id: publicId,
  resource_type: resourceType,
  version,
  breakpoints,
  imageData,
  onImageLoad,
  fullScreenVideo,
  type,
  quality,
  ...otherProps
}) {
  if (resourceType === 'video') {
    return (
      <Video
        autoPlay={autoPlay}
        fullScreen={fullScreenVideo}
        className={className}
        poster={buildUrl(
          'webp',
          publicId,
          'video',
          type,
          version,
          1200,
          'auto',
        )}
        srcset={buildVideoUrls(publicId, type, version, breakpoints, quality)}
        {...otherProps}
      />
    );
  }
  if (resourceType === 'image' && imageData) {
    return (
      <GatsbyImage
        alt={imageData?.context?.custom?.alt || ''}
        className={className}
        image={imageData.gatsbyImageData}
        onLoad={onImageLoad}
      />
    );
  }
  return null;
}
